<template>
<v-card flat>
	<v-card-text class="pt-3">
		<v-row class="px-3">
			<bee-simple-table :with-color="true" :zebra="false"  :hide-footer="true" empty-state="dashes"
				:addable="false" :editable="false" :configs="configs" :headers="[
					{ text: $t('Matchings.bond-no'), value: 'bond_id', type: 'autocomplete', width: '5%', settings: {itemText: 'bond_no', itemValue: 'id', items: simplified_accounting_bonds} },
					{ text: $t('Matchings.entry-no'), value: 'order_inside_bond', type: 'string', width: '4%', },
					{ text: $t('Matchings.debit'), value: 'debit', type: 'money', width: '9%',},
					{ text: $t('Matchings.credit'), value: 'credit', type: 'money', width: '9%',},
					{ text: $t('Matchings.currency-debit'), value: 'currency_debit', type: 'money', width: '9%',},
					{ text: $t('Matchings.currency-credit'), value: 'currency_credit', type: 'money', width: '9%',},
					{ text: $t('Matchings.currency-price'), value: 'currency_price', type: 'numeric', width: '10%', settings: { itemText: 'equivalentPrice' },},
					{ text: $t('Matchings.balance'), value: 'balance', type: 'numeric', width: '10%', settings: { itemText: 'equivalentPrice' },},
					{ text: $t('Matchings.currency'), value: 'currency', type: 'currencies-autocomplete', width: '4%', settings: { itemText: 'symbol' }},
					{ text: $t('Matchings.date'), value: 'date', type: 'date', width: '7%'},
					{ text: $t('Matchings.paper-document-no'), value: 'paper_document_no', type: 'string', width: '4%',   },
					{ text: $t('Matchings.note'), value: 'note', type: 'string', width: '13%',},
					{ text: $t('Matchings.matching-date'), value: 'matching_date', type: 'date', width: '7%'},
					]"
				:items="advancedEntries || []">
			</bee-simple-table>
		</v-row>
	</v-card-text>
</v-card>
</template>
<script>
import  store  from "../../../../store/index.js";
import {  mapState } from "vuex";
export default {
computed: {
	...mapState("statements", ["matchedEntries"]),
	...mapState("configs", ["configs"]),
	...mapState("bonds", ["simplified_accounting_bonds"]),
	file_is_locked(){
        return this.configs?.financial_file?.is_locked },
	advancedEntries(){
		return this.matchedEntries?.map(obj=> ({ ...obj, currency: obj.currency_credit ? obj.currency_credit.currency_id : (obj.currency_debit ? obj.currency_debit.currency_id : null)}) )
	}
},

async beforeRouteEnter(to, from, next) {
	let promises = []

	let object = JSON.parse(JSON.stringify(store.state.configs.configs))
	if(Object.keys(object).length == 0)
		promises.push(store.dispatch("configs/fetchAll"))

	if (to.params.id)
		promises.push(store.dispatch("statements/fetchMatchedEntries", to.params.id ))

	if(promises.length)
		await Promise.all(promises)

	next();
}
}
</script>